import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "com_title1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "関連情報リンク")
], -1)
const _hoisted_2 = { class: "com_related-inks1" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "banner1" }
const _hoisted_5 = ["src", "alt", "onError"]
const _hoisted_6 = {
  key: 0,
  class: "t1"
}
const _hoisted_7 = { class: "text1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerListData, (banner, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: banner.bannerName,
          href: banner.bannerUrl,
          target: "_blank"
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.imageSources[index] + '?v=' + new Date().getTime(),
              alt: banner.bannerName,
              onError: ($event: any) => (_ctx.handleImageError(index))
            }, null, 40, _hoisted_5),
            (_ctx.imageError[index])
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(banner.bannerName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(banner.bannerCaption), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 64))
}